import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";
import { brandRoute } from "../../../../helpers/restaurantSlugDetector";
import { connect } from "react-redux";
import { setFavoriteRest } from "../../../../services/items/actions";
import StoreCoupons from "../../Items/RestaurantInfo/StoreCoupons";

class SingleStore extends Component {
	state = {
		withLinkToRestaurant: false,
		isFavorite: false,
	};

	componentDidMount() {
		this.setState({ withLinkToRestaurant: this.props.withLinkToRestaurant });

		if (this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.fromExplorePage) {
			this.setState({ withLinkToRestaurant: this.props.history.location.state.fromExplorePage });
		}

		this.registerScrollEvent();
	}

	componentWillUnmount() {
		this.removeScrollEvent();
	}

	fixedRestaurantInfo = (hidden) => {
		if (this.child) {
			if (hidden) {
				this.child.heading.classList.add("hidden");
			} else {
				this.child.heading.classList.remove("hidden");
			}
		}
	};

	registerScrollEvent() {
		window.addEventListener("scroll", this.scrollFunc);
	}
	removeScrollEvent() {
		window.removeEventListener("scroll", this.scrollFunc);
	}
	scrollFunc = () => {
		if (document.documentElement.scrollTop > 55) {
			let hidden = false;
			this.fixedRestaurantInfo(hidden);
		}
		if (document.documentElement.scrollTop < 55) {
			let hidden = true;
			this.fixedRestaurantInfo(hidden);
		}
	};

	setFavoriteRestaurant = () => {
		const { restaurant_info, user } = this.props;
		if (user.success) {
			if (restaurant_info.is_favorited) {
				this.refs.heartIcon.classList.remove("is-active");
			} else {
				this.refs.heartIcon.classList.add("is-active");
			}
			this.props.setFavoriteRest(user.data.auth_token, restaurant_info.id);
		}
	};

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.restaurant_info !== prevState.restaurant_info) {
			return {
				data: nextProps.restaurant_info,
			};
		} else {
			return null;
		}
	}

	render() {
		const { history, restaurant, user } = this.props;
		
		// Handle both array and object formats
		// If restaurant is an array, get the first element; otherwise use the object directly
		const restaurantData = Array.isArray(restaurant) 
			? (restaurant.length > 0 ? restaurant[0] : null)
			: restaurant;
		
		// Check if we have valid restaurant data
		const hasRestaurant = restaurantData && restaurantData.id;
		
		console.log('🏪 SingleStore - restaurant prop:', restaurant, 'restaurantData:', restaurantData, 'hasRestaurant:', hasRestaurant);
		
		return (
			<React.Fragment>
				<div className="bg-white">
					{!hasRestaurant ? (
						<div style={{ paddingTop:"35px" }}>
						<ContentLoader
							className="custom-gradle-bg"
							height={170}
							width={400}
							speed={1.2}
							primaryColor="#f3f3f3"
							secondaryColor="#ecebeb"
						>
							<rect x="20" y="70" rx="4" ry="4" width="80" height="78" />
							<rect x="144" y="85" rx="0" ry="0" width="115" height="18" />
							<rect x="144" y="115" rx="0" ry="0" width="165" height="16" />
						</ContentLoader>
						</div>
					) : (
						<React.Fragment>
							<Link
								to={"../../stores/" + restaurantData.slug}
								className={`store-info-itemspage ${this.state.withLinkToRestaurant ? "" : "no-click"}`}
							>
								<div>
									<div className="custom-gradle-bg">
										<div className="row">
											<div className={`${restaurant.is_appview === 0 ? "col-12" : "col-10"}`}>
												<div className="ml-5 px-15 mt-5 w-100">
													<h4 className="res-info-name mb-5 text-dark break-word">{restaurant.name}</h4>
													<div className="font-size-sm truncate-text res-info-desc">
														{/* {restaurant.description} */}
													</div>
												</div>
											</div>
										</div>
										<hr className="mr-15 ml-15 res-ino-division-hr" />
										{restaurant.is_appview === 0 ? (
										<div className="col-12 res-info-time-wrap" style={{ display: 'flex', alignItems: 'center' }}>
										</div>
										):(
										<div className="container">
											<div className="row">
												<div className="col-4 text-center">
												<span className="icon-star"></span><span className="ml-1 new-time-wrap">{restaurant.avgRating === "0" ? (
													<React.Fragment>
														{restaurant.rating}
													</React.Fragment>
												) : (
													<React.Fragment>
													<Link to={brandRoute("/reviews/" + restaurant.slug)} style={{ display: "contents" }} className="yes-click new-time-wrap"> {restaurant.avgRating}
													</Link>
													</React.Fragment>
												)}</span>
												<p className="mb-1 res-info-new-wraper">100+ ratings</p>
												</div>
												<div className="col-4 text-center">
												<span className="new-time-wrap">{restaurant.delivery_time}{" "}{localStorage.getItem("homePageMinsText")}</span>
												<p className="mb-1 res-info-new-wraper">Delivery Time</p>
												</div>
												<div className="col-4 text-center">
												<span>{localStorage.getItem("currencySymbolAlign") === "left" && (
														<React.Fragment>
															<span className="new-time-wrap">
															{localStorage.getItem("currencyFormat")}
															{restaurant.price_range}{" "}
															</span>
														</React.Fragment>
													)}
													{localStorage.getItem("currencySymbolAlign") === "right" && (
														<React.Fragment>
															<span className="new-time-wrap">
															{restaurant.price_range}
															{localStorage.getItem("currencyFormat")}{" "}
															</span>
														</React.Fragment>
													)}
												</span>
												<p className="mb-1 res-info-new-wraper">{localStorage.getItem("homePageForTwoText")}</p>
												</div>
											</div>
										</div>
										)}
									</div>
								</div>
							</Link>
						</React.Fragment>
					)}
				</div>
				<StoreCoupons coupons={restaurant.coupons}/>
				{restaurant.custom_message !== "<p><br></p>" &&
					restaurant.custom_message !== "null" &&
					(restaurant.custom_message !== "" && (
						<div
							style={{
								position: "relative",
								background: "#fff",
							}}
							dangerouslySetInnerHTML={{
								__html: restaurant.custom_message,
							}}
						/>
					))}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	restaurant_info: state.items.restaurant_info,
	user: state.user.user,
});

export default connect(
	mapStateToProps,
	{ setFavoriteRest }
)(SingleStore);
